module.exports = __webpack_public_path__ + "cn.29d9cf35217b2035fbe0.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/cn.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/cn.svg
// module chunks = styles